import { FunctionalComponent, h } from "preact";
import { useState, useEffect } from "preact/hooks";
import { Link } from "preact-router";
import style from "./AIToggle.module.css";
import { useAppSelector } from "../../redux/hooks";

interface AIToggleProps {
  value?: string;
  active: string;
  setActive: (value: string) => void;
}

const AIToggle: FunctionalComponent<AIToggleProps> = ({
  value,
  active,
  setActive,
}) => {
  const alias = useAppSelector((state) => state.alias);

  const options = [
    {
      name: "Smart Search",
      href: `/${alias.workspaceAlias}/${alias.portalAlias}/`,
      tooltip: "AI-powered answers with the most relevant documents suggested for your question",
    },
    {
      name: "Keyword Search",
      href: `/${alias.workspaceAlias}/${alias.portalAlias}/keywordHome`,
      tooltip: "Search documents by exact keywords in titles, names, or content",
    },
  ];

  useEffect(() => {
    if (
      window.location.pathname.includes("keywordHome") ||
      window.location.pathname.includes("keywordSearch")
    ) {
      setActive("Keyword Search");
    } else {
      setActive("Smart Search");
    }
  }, []);

  return (
    <div class={style.toggleContainer}>
      {options.map((option) => (
        <Link
          key={option.name}
          href={option.href}
          title={option.tooltip} // ✅ TOOLTIP ADDED HERE
          class={`${style.option} ${
            active === option.name ? style.active : ""
          }`}
          onClick={() => setActive(option.name)}
        >
          {option.name}
        </Link>
      ))}
    </div>
  );
};

export default AIToggle;
